/**
 * Returns the type of an object embedded by a plan point.
 * @param {Object} point - point object
 * @returns {string} object type
 */
export const getPointObjectType = point =>
  point.channel ? 'channel' : point.device ? 'device' : point.marker ? 'marker' : 'unknown'
